module.exports = __webpack_public_path__ + "img/free_bidding_submit.d890392b.png";